import Vue from 'vue'
import VueRouter from 'vue-router'
import mine from '../../views/mine/mine.vue'
import setCenter from '../../views/mine/personalSetting/index.vue'
import aboutUs from '../../views/mine/personalSetting/aboutUs.vue'
import personalCenter from '../../views/mine/personalSetting/personalCenter.vue'
import purchaserecord from '../../views/mine/control/purchaserecord.vue'
import cloudPhoneSetup from '../../views/mine/control/cloudPhoneSetup.vue'
import equipmentShift from '../../views/mine/equipmentShift/index.vue'
import choiceDevice from '../../views/mine/equipmentShift/choiceDevice.vue'
import transferResults from '../../views/mine/equipmentShift/transferResults.vue'
import equipmentauthorization from '../../views/mine/accredit/equipmentauthorization.vue'
import selectionInstance from '../../views/mine/accredit/selectionInstance.vue'
import authorizationrecord from '../../views/mine/accredit/authorizationrecord.vue'
import activationCodeUsage from '../../views/mine/activationCode/activationCodeUsage.vue'
import activationResult from '../../views/mine/activationCode/activationResult.vue'
import choosecloudphone from '../../views/mine/activationCode/choosecloudphone.vue'
import commissionSharing from '../../views/mine/control/commissionSharing.vue'
import messageCenter from '../../views/mine/control/messageCenter.vue'
import proxyIp from '../../views/mine/proxyIp/index.vue'
import choiceProxyDevice from '../../views/mine/proxyIp/choiceProxyDevice.vue'
import proxyIpRecord from '../../views/mine/proxyIp/proxyIpRecord.vue'
Vue.use(VueRouter)

const MINE = [
    {
        path: '/mine',
        name: 'Mine',
        component: mine
    },
    {
        path: '/setCenter',
        name: 'SetCenter',
        component: setCenter
    },
    {
        path: '/aboutUs',
        name: 'AboutUs',
        component: aboutUs
    },
    {
        path: '/personalCenter',
        name: 'PersonalCenter',
        component: personalCenter
    },
    {
        path: '/purchaserecord',
        name: 'Purchaserecord',
        component: purchaserecord
    },
    {
        path: '/cloudPhoneSetup',
        name: 'CloudPhoneSetup',
        component: cloudPhoneSetup
    },
    {
        path: '/equipmentShift',
        name: 'EquipmentShift',
        component: equipmentShift
    },
    {
        path: '/choiceDevice',
        name: 'ChoiceDevice',
        component: choiceDevice
    },
    {
        path: '/transferResults',
        name: 'TransferResults',
        component: transferResults
    },
    {
        path: '/equipmentauthorization',
        name: 'Equipmentauthorization',
        component: equipmentauthorization
    },
    {
        path: '/selectionInstance',
        name: 'SelectionInstance',
        component: selectionInstance
    },
    {
        path: '/authorizationrecord',
        name: 'Authorizationrecord',
        component: authorizationrecord
    },
    {
        path: '/activationCodeUsage',
        name: 'ActivationCodeUsage',
        component: activationCodeUsage
    },
    {
        path: '/activationResult',
        name: 'ActivationResult',
        component: activationResult
    },
    {
        path: '/choosecloudphone',
        name: 'Choosecloudphone',
        component: choosecloudphone
    },
    {
        path: '/commissionSharing',
        name: 'CommissionSharing',
        component: commissionSharing
    },
    {
        path: '/messageCenter',
        name: 'MessageCenter',
        component: messageCenter
    },
    {
        path: '/proxyIP',
        name: 'ProxyIP',
        component: proxyIp
    },
    {
        path: '/choiceProxyDevice',
        name: 'ChoiceProxyDevice',
        component: choiceProxyDevice
    },
    {
        path: '/proxyIpRecord',
        name: 'ProxyIpRecord',
        component: proxyIpRecord
    },
]

export default MINE
